export interface InitError {
  code: string;
  // Whether an outdated bundle can cause it against a newer backend, so a fresh client may fix it.
  reloadWithFreshClient: boolean;
}

// Codes select the page in errorI18n; unknown ones show the generic page.
export const INIT_ERRORS = {
  token: { code: "token", reloadWithFreshClient: false },
  version: { code: "version", reloadWithFreshClient: false },
  getUser: { code: "get-user", reloadWithFreshClient: true },
  config: { code: "config", reloadWithFreshClient: true },
  data: { code: "data", reloadWithFreshClient: true },
  experimentation: {
    code: "useInitApp: Experimentation Test ERROR",
    reloadWithFreshClient: true,
  },
  uncaught: { code: "init", reloadWithFreshClient: true },
} as const satisfies Record<string, InitError>;
